import { useAdminStore } from '@/stores/adminStore';

function StatCard({ label, value, unit }: { label: string; value: string | number; unit?: string }) {
  return (
    <div className="bg-bg-tertiary/50 border border-border-subtle rounded-xl p-4">
      <div className="text-[11px] text-text-muted mb-1">{label}</div>
      <div className="text-xl font-bold font-mono text-text-primary">
        {value}
        {unit && <span className="text-xs text-text-muted ml-1">{unit}</span>}
      </div>
    </div>
  );
}

function RankList({ title, data }: { title: string; data: Record<string, number> }) {
  const entries = Object.entries(data).sort(([, a], [, b]) => b - a);
  if (entries.length === 0) return null;

  const max = entries[0][1] || 1;

  return (
    <div>
      <h4 className="text-xs font-semibold text-text-secondary mb-2">{title}</h4>
      <div className="space-y-1.5">
        {entries.map(([name, count]) => (
          <div key={name} className="flex items-center gap-2">
            <span className="text-[11px] text-text-secondary w-24 truncate">{name}</span>
            <div className="flex-1 h-4 bg-bg-tertiary rounded-full overflow-hidden">
              <div
                className="h-full bg-accent-blue/40 rounded-full transition-all"
                style={{ width: `${(count / max) * 100}%` }}
              />
            </div>
            <span className="text-[11px] font-mono text-text-muted w-8 text-right">{count}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function PerformanceTab() {
  const perf = useAdminStore((s) => s.performance);

  if (!perf) {
    return (
      <div className="text-center text-text-muted text-sm py-12">
        Sin datos de rendimiento
      </div>
    );
  }

  return (
    <div className="space-y-5">
      {/* Stats grid */}
      <div className="grid grid-cols-3 gap-3">
        <StatCard
          label="Tiempo promedio"
          value={(perf.avg_response_time_ms / 1000).toFixed(1)}
          unit="s"
        />
        <StatCard
          label="Queries / hora"
          value={perf.queries_per_hour}
        />
        <StatCard
          label="Total periodo"
          value={perf.total_queries_period}
        />
      </div>

      {/* Top users */}
      <RankList title="Top usuarios" data={perf.top_users} />

      {/* Top executors */}
      <RankList title="Top executors" data={perf.top_executors} />
    </div>
  );
}
